<template>
  <div class="tracking-types" v-if="hasServices">
    <span class="service" v-for="service, i in services" :key="`service-${i}`" @click="handleService(service.service)"
          :class="{ 'active' : activeService === service.service }">
      <img
        :src="getService(service.service).logo"
        v-tooltip="getService(service.service).tooltip"
        @click="handleService(service.service)"
      />
    </span>
  </div>
</template>

<script>

  import IntegrationsApi from '../../../api/Integrations';


  export default {
    name: 'service-tracking-types',
    props: {
      type: {
        type: String,
        required: true,
        default: 'sleep'
      },
      serviceList: {
        type: Array,
        default: []
      },
      currentService: {
        type: String,
        default: 'LCP'
      }
    },
    data() {
      return {
        isLoading: true,
        services: [],
        activeService: 'LCP'
      }
    },
    methods: {
      capitalize(txt) {
        return _.capitalize(txt);
      },
      getIntegrationsWithType() {
        let self = this;
        if (self.type === 'sleep') {
          IntegrationsApi.available.sleep().then(response => {
            self.pushServices(response.data);
            self.$nextTick(function () {
              self.activeService = self.currentService;
            })

            self.isLoading = false;
          });
        }
        if (self.type === 'activity') {
          IntegrationsApi.available.activity().then(response => {
            self.pushServices(response.data);
            self.$nextTick(function () {
              self.activeService = self.currentService;
            })

            self.isLoading = false;
          });
        }
      },
      initMounted() {
        let self = this;
        self.isLoading = true;

        if(self.serviceList.length === 0) {
          self.services.push({
            service: 'LCP',
          });
          self.getIntegrationsWithType();
        }
        else {
          self.services = self.serviceList;
          self.activeService = self.currentService;
        }


      },
      pushServices(services) {
        let self = this;
        services.forEach((service, i) => {
          self.services.push(service);
        });
      },
      getService(service) {
        let self = this,
          fileName = null,
          tooltip = null;
        switch (service) {
          case 'LCP' :
            fileName = 'lcp.png';
            tooltip = 'Low Carb Program';
            break;
          case 'FITBIT' :
            fileName = 'fitbit.svg';
            tooltip = 'FitBit';
            break;
          case 'STRIIV' :
            fileName = 'striiv.png';
            tooltip = 'Striiv';
            break;
        }
        return {
          logo: `static/integrations/${fileName}`,
          tooltip: `${tooltip} ${self.capitalize(self.type)} Data`
        }
      },
      handleService(service) {
        let self = this;
        self.activeService = service;
        let key = 'onTrackingType_' + self.type;
        self.$emit(key, self.activeService);
        self.$EventBus.$emit(key, self.activeService);
      },
    },
    mounted() {
      let self = this;
      self.initMounted();
    },
    computed: {
      hasServices() {
        let self = this;
        return self.services.length !== 0;
      }
    }
  }

</script>

<style lang="less">
  @import "../../../styles/theme.less";

  .tracking-types {
    float: right;
    margin: 0 24px;
    background-color: #EEF8FF;
    border-radius: 18px;
    overflow: hidden;
    .service {
      float: left;
      padding: 7px 12px;
      cursor: pointer;
      font-size: 0;
      &.active {
        background-color: @primaryColor;
        img {
          border-color: #FFF;
          border-radius: 100%;
        }
      }
      img {
        width: 27px;
        height: auto;
        border: 1px solid transparent;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ServiceTrackingTypes.vue?7ae82e7e